import PropTypes from 'prop-types'
import React from 'react'
import { Grid } from '@material-ui/core'

const FormRow = ({ spacing, children }) => {
  return (
    <Grid container spacing={spacing}>
      {children}
    </Grid>
  )
}

FormRow.defaultProps = {
  spacing: 2,
}

FormRow.propTypes = {
  spacing: PropTypes.number,
  children: PropTypes.node.isRequired,
}

export default FormRow
